// e.g. https://api.zillionairejewels.com/api/v1/admin (set at build time via .env-cmdrc)
export const baseUrl = process.env.REACT_APP_baseUrl || "http://127.0.0.1:8082/api/v1/admin";
// Storefront URL, used for "view on site" links
export const storefrontUrl = (process.env.REACT_APP_STOREFRONT_URL || "https://zillionairejewels.com").replace(/\/$/, "");
